/* src/app/modules_v2/income/grant/components/grant-detail-tabs/grant-detail-tabs.component.scss */
:host {
  display: block;
}
.gd-panel {
  display: grid;
  grid-template-columns: minmax(240px, 1fr) minmax(0, 2fr);
  gap: 16px;
}
.gd-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 14px 16px;
  min-width: 0;
}
.gd-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}
.gd-card__title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 700;
  color: #1a1d23;
}
.gd-card__title mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: #6b7280;
}
.gd-info {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.gd-info__row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  min-width: 0;
}
.gd-info__icon {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: #f4f6f8;
  display: flex;
  align-items: center;
  justify-content: center;
}
.gd-info__icon mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: #6b7280;
}
.gd-info__text {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.gd-info__label {
  font-size: 12px;
  color: #6b7280;
}
.gd-info__value {
  font-size: 14px;
  font-weight: 600;
  color: #1a1d23;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.gd-info__value--muted {
  font-weight: 400;
  color: #9ca3af;
}
.gd-progress {
  margin-bottom: 12px;
}
.gd-progress__bar {
  height: 8px;
  border-radius: 999px;
  background: #eef1f4;
  overflow: hidden;
}
.gd-progress__fill {
  height: 100%;
  border-radius: 999px;
  background: #c5d94a;
  transition: width 0.3s ease;
}
.gd-progress__legend {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
  font-size: 12px;
  color: #6b7280;
}
.gd-progress__legend strong {
  color: #1a1d23;
  font-variant-numeric: tabular-nums;
}
.gd-table-wrap {
  max-height: 220px;
  overflow: auto;
  border: 1px solid #eef1f4;
  border-radius: 8px;
}
.gd-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.gd-table th {
  position: sticky;
  top: 0;
  background: #f4f6f8;
  color: #6b7280;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  text-align: left;
  padding: 8px 12px;
}
.gd-table td {
  padding: 7px 12px;
  color: #2f3540;
  border-top: 1px solid #eef1f4;
}
.gd-table tr:hover td {
  background: #fafbfc;
}
.gd-num {
  text-align: right !important;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.gd-empty {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  background: #f9fafb;
  border: 1px dashed #e5e7eb;
  border-radius: 8px;
  font-size: 13px;
  color: #6b7280;
}
.gd-empty mat-icon {
  flex-shrink: 0;
  font-size: 20px;
  width: 20px;
  height: 20px;
}
@media (max-width: 900px) {
  .gd-panel {
    grid-template-columns: 1fr;
  }
}
/*# sourceMappingURL=grant-detail-tabs.component.css.map */
